import React from "react";
import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexRowDiv } from "./common.styles";
import { Subtitle as HXSubtitle, mobilePageHPadding } from "./HXMobilePage.styles";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Stack from "@mui/material/Stack";
export const HeaderContainer = styled(FlexRowDiv) `
    align-self: stretch;
    display: flex;
    padding: 16px ${mobilePageHPadding}px;
    justify-content: space-between;
    align-items: center;
    border-bottom: ${(props) => (props.showBottomBorder ? "1px" : "0")} solid ${colors.black_12};

    ${(props) => props.padding &&
    css `
            padding: ${props.padding};
        `}
`;
const NavigationButtonsStack = styled(Stack).attrs({
    direction: "row",
    spacing: "0",
}) `
    width: ${(props) => (props.width !== undefined ? `${props.width}px !important` : "auto")};
`;
export const NavigationLeftButtonsStack = styled(NavigationButtonsStack).attrs({
    direction: "row",
    spacing: "0",
}) `
    justify-content: start;
    align-items: center;

    /* Remove left padding from the first (leftmost) button */
    > :first-child {
        padding-left: 0 !important;
    }
`;
export const NavigationRightButtonsStack = styled(NavigationButtonsStack).attrs({
    direction: "row",
    spacing: "0",
}) `
    justify-content: end;
    align-items: center;

    /* Remove right padding from the last (rightmost) button */
    > :last-child {
        padding-right: 0 !important;
    }
`;
export const Title = styled(HXSubtitle) ``;
export const CloseButton = styled(IconButton).attrs({
    size: "medium",
    children: React.createElement(ChevronLeftIcon),
}) ``;
export const PaddingButton = styled.div `
    width: 40px;
    height: 40px;
`;
